const s = {
  page: { minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: 'Inter, sans-serif', padding: '40px 20px' },
  card: { maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: '48px' },
  header: { textAlign: 'center' as const, marginBottom: '40px', borderBottom: '2px solid #FF6A3D', paddingBottom: '24px' },
  logo: { fontSize: '28px', fontWeight: 800, color: '#FF6A3D', marginBottom: '8px' },
  subtitle: { color: '#666', fontSize: '14px' },
  h2: { fontSize: '18px', fontWeight: 700, color: '#1a1a1a', marginTop: '32px', marginBottom: '12px' },
  p: { color: '#444', lineHeight: 1.7, fontSize: '15px', marginBottom: '12px' },
  ul: { color: '#444', lineHeight: 1.8, fontSize: '15px', paddingLeft: '20px', marginBottom: '12px' },
  highlight: { backgroundColor: '#fff4f0', border: '1px solid #FF6A3D', borderRadius: '8px', padding: '16px 20px', marginBottom: '16px' },
  footer: { marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #eee', textAlign: 'center' as const, color: '#999', fontSize: '13px' },
};

export const DeleteDataPage = () => (
  <div style={s.page}>
    <div style={s.card}>
      <div style={s.header}>
        <div style={s.logo}>EncoreEats</div>
        <div style={{ fontSize: '22px', fontWeight: 700, color: '#1a1a1a', marginBottom: '6px' }}>Eliminación de Datos Personales</div>
        <div style={s.subtitle}>Data Deletion Request · Última actualización: mayo 2026</div>
      </div>

      <p style={s.p}>
        En <strong>EncoreEats</strong> respetamos su derecho a controlar sus datos personales. Esta página explica cómo puede solicitar la eliminación de su información de nuestra plataforma.
      </p>

      <h2 style={s.h2}>¿Qué datos almacenamos?</h2>
      <ul style={s.ul}>
        <li>Nombre completo, correo electrónico y número de teléfono</li>
        <li>Dirección de entrega y ubicación geográfica</li>
        <li>Historial de pedidos y preferencias</li>
        <li>Foto de perfil (si fue proporcionada)</li>
        <li>Token de notificaciones push</li>
        <li>Datos de uso de la aplicación</li>
      </ul>

      <h2 style={s.h2}>Cómo solicitar la eliminación de sus datos</h2>
      <p style={s.p}>
        Para solicitar la eliminación de sus datos personales, envíe un correo electrónico a la siguiente dirección indicando su nombre completo y el correo asociado a su cuenta:
      </p>
      <div style={s.highlight}>
        <strong>Correo de contacto:</strong>{' '}
        <a href="mailto:encoreeat@gmail.com" style={{ color: '#FF6A3D', textDecoration: 'none' }}>
          encoreeat@gmail.com
        </a>
        <br />
        <strong>Asunto sugerido:</strong> Solicitud de eliminación de datos — [tu correo registrado]
      </div>

      <h2 style={s.h2}>¿Qué se elimina con su solicitud?</h2>
      <ul style={s.ul}>
        <li>Información de perfil (nombre, foto, teléfono)</li>
        <li>Direcciones guardadas</li>
        <li>Historial de pedidos</li>
        <li>Preferencias y configuración de la cuenta</li>
        <li>Token de notificaciones push</li>
      </ul>

      <h2 style={s.h2}>Datos que pueden ser retenidos</h2>
      <p style={s.p}>
        Algunos datos pueden conservarse por obligaciones legales o fiscales (por ejemplo, registros de transacciones requeridos por la normativa aplicable). Estos datos no se usarán para ningún otro fin y serán eliminados una vez vencido el período legal obligatorio.
      </p>

      <h2 style={s.h2}>Tiempo de respuesta</h2>
      <p style={s.p}>
        Procesaremos su solicitud en un plazo máximo de <strong>30 días hábiles</strong> a partir de la recepción del correo. Recibirá una confirmación una vez que sus datos hayan sido eliminados.
      </p>

      <h2 style={s.h2}>Eliminación desde la aplicación</h2>
      <p style={s.p}>
        También puede eliminar su cuenta directamente desde la aplicación EncoreEats accediendo a <strong>Perfil → Configuración → Eliminar cuenta</strong>. Esto eliminará automáticamente todos sus datos personales.
      </p>

      <div style={s.footer}>
        © 2026 EncoreEats. Todos los derechos reservados.
      </div>
    </div>
  </div>
);
